var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('topheader'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"left"},[_c('zhhyLeft')],1),_c('div',{staticClass:"middle"},[_c('zhhymiddle')],1),_c('div',{staticClass:"right"},[_c('zhhyRight')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }